import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useContext, useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import { P as PortalContextProvider } from './PortalContext-CNkIMMvm.js';
import { a as adoptAncestorZIndex } from './adoptAncestorZIndex-C3h4wKUG.js';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

/**
 * The InlinePortalProvider is used to create a portal to render popover content
 * within a modal-like elements. This allows tab focus work and prevents
 * custom modal z-index from hiding popovers.
 */
const InlinePortalProvider = ({
  children = null,
  ...rest
}) => {
  var _useContext$inlinePor, _useContext;
  const portalRef = useRef(null);
  const zIndexIncrement = (_useContext$inlinePor = (_useContext = useContext(ThemeContext)) === null || _useContext === void 0 ? void 0 : _useContext.inlinePortalZIndexIncrement) !== null && _useContext$inlinePor !== void 0 ? _useContext$inlinePor : 10000;
  useEffect(() => {
    /** Assign a `z-index` value based on the closest ancestor with a non-auto `z-index` and
     * increment it to prevent parent modal-like elements from cutting through. */
    adoptAncestorZIndex(portalRef, zIndexIncrement);
  }, [zIndexIncrement]);
  return /*#__PURE__*/React__default.createElement(PortalContextProvider, {
    portalElementRef: portalRef
  }, children, /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: portalRef
  })));
};

export { InlinePortalProvider as I };
//# sourceMappingURL=InlinePortalProvider-DpZ1TsoC.js.map
